module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "uk-margin"
  }, [_c('div', {
    staticClass: "uk-inline"
  }, [_c('span', {
    staticClass: "uk-form-icon uk-form-icon-flip",
    attrs: {
      "uk-icon": "icon: calendar"
    }
  }), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "config": _vm.configArrival,
      "placeholder": _vm.textArrival,
      "input-class": "uk-input uk-form-width-medium",
      "type": "text"
    },
    model: {
      value: (_vm.arrival),
      callback: function($$v) {
        _vm.arrival = $$v
      },
      expression: "arrival"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-inline"
  }, [_c('span', {
    staticClass: "uk-form-icon uk-form-icon-flip",
    attrs: {
      "uk-icon": "icon: calendar"
    }
  }), _vm._v(" "), _c('flat-pickr', {
    attrs: {
      "config": _vm.configDeparture,
      "placeholder": _vm.textDeparture,
      "input-class": "uk-input uk-form-width-medium",
      "type": "text"
    },
    model: {
      value: (_vm.departure),
      callback: function($$v) {
        _vm.departure = $$v
      },
      expression: "departure"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-inline"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.send($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.textButton))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8006fba2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 157
// module chunks = 0